import { persistentAtom } from './persistence';
import type { Tag } from '@/data/logs';

/**
 * Global tags - persist across logbooks
 */
export const $tags = persistentAtom<Tag[]>('tags', [
  {
    id: 'tag-1',
    name: 'Important',
    color: '#ff0000',
  },
  {
    id: 'tag-2',
    name: 'R/C No Response',
    color: '#ff8800',
    rules: [
      {
        enabled: true,
        priority: 2,
        logic: 'AND',
        conditions: [
          {
            type: 'description',
            operator: 'startsWith',
            value: 'rc no',
            caseSensitive: false,
          },
        ],
      },
    ],
  },
  {
    id: 'tag-3',
    name: 'R/C',
    color: '#0088ff',
    rules: [
      {
        enabled: true,
        priority: 1,
        logic: 'AND',
        conditions: [
          {
            type: 'description',
            operator: 'startsWith',
            value: 'rc',
            caseSensitive: false,
          },
        ],
      },
    ],
  },
  {
    id: 'tag-4',
    name: 'SITREP',
    color: '#22ff44',
  },
]);
